import React$1, { useState, useEffect } from 'react';
import PropTypes$1 from 'prop-types';
import Button$1 from '../../basics/Button/Button.js';
import Text$1 from '../../basics/Text/Text.js';
import Cookies$1 from 'js-cookie';
import { useTransition, animated } from 'react-spring';
import StyledCookieLayer from './CookieLayer.style.js';

const CookieLayer = ({
  text,
  acceptLabel,
  rejectLabel
}) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const cookies = Cookies$1.get('acceptCookies');
    setIsVisible(typeof cookies === 'undefined');
  }, []);

  const handleClick = value => {
    // also see Text component for custom optout/optin links
    Cookies$1.set('acceptCookies', value, {
      expires: 14
    });
    setIsVisible(false);
  };

  const transitions = useTransition(isVisible, null, {
    from: {
      transform: 'translateY(600px)'
    },
    enter: {
      transform: 'translateY(0)'
    },
    leave: {
      transform: 'translateY(600px)'
    }
  });
  return transitions.map(({
    item,
    key,
    props
  }) => item && /*#__PURE__*/React$1.createElement(StyledCookieLayer, {
    as: animated.div,
    hasOuterMargins: false,
    key: key,
    style: props
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "cookieLayer__content"
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "cookieLayer__inner"
  }, /*#__PURE__*/React$1.createElement(Text$1, {
    content: text,
    className: "cookieLayer__text"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "cookieLayer__actions"
  }, /*#__PURE__*/React$1.createElement(Button$1, {
    className: "cookieLayer__button",
    onClick: () => handleClick('accept'),
    icon: "tick"
  }, acceptLabel), /*#__PURE__*/React$1.createElement(Button$1, {
    className: "cookieLayer__button",
    variant: "secondary",
    onClick: () => handleClick('reject'),
    icon: "cross"
  }, rejectLabel))))));
};

CookieLayer.propTypes = {
  text: PropTypes$1.string.isRequired,
  acceptLabel: PropTypes$1.string.isRequired,
  rejectLabel: PropTypes$1.string.isRequired
};

export default CookieLayer;
